<template>
  <div>
    <div class="container" v-if="customer">
      <!-- 客户信息 -->
      <div class="card">
        <!-- <div class="title" style="margin-left:10px">
          <svg class="icon" aria-hidden="true">
            <use xlink:href="#icon-post"></use>
          </svg>
          <span >{{customer.custName}}</span>
          <van-icon name="edit" color="#f8df0d" size="20px" class="icon-edit" v-hasPermi="['scrm:customer:edit']" @click="edit"/>
          <van-icon name="delete" color="red" size="20px" class="icon-delete" v-hasPermi="['scrm:customer:remove']" @click="remove" />
        </div> -->
        <div class="title">
          <svg class="icon" aria-hidden="true">
            <use xlink:href="#icon-post"></use>
          </svg>
          <span>{{customer.custName}}</span>
          <!-- <van-tag type="primary">{{formatHandel('custStatus',customer.custStatus)}}</van-tag> -->
          <!-- <img class="modify_img" src="../../../assets/images/desktop/modify.png" @click="edit" > -->
        </div>
        <div class="tag_box">
          <van-tag type="primary" v-if="customer.custStatus">{{ formatHandel('custStatus',customer.custStatus) }}</van-tag>
          <van-tag type="primary" v-if="customer.custSource">{{ formatHandel('custSource',customer.custSource) }}</van-tag>
          <van-tag type="primary" v-if="customer.custLevel">{{ formatHandel('custLevel',customer.custLevel) }}</van-tag>
          <van-tag type="primary" v-if="customer.unitNature">{{ formatHandel('unitNature',customer.unitNature) }}</van-tag>
          <van-tag type="primary" v-if="customer.industryNam">{{ customer.industryName }}</van-tag>
        </div>
        <!-- <div class="tab-line"> -->
        <!-- <van-tabs v-model="active">
          <van-tab title="基本信息"> -->
            <div class="list-wrap van-hairline--top">
              <!-- <div class="item" style="width:100%;">
                <span class="key">客户简称：</span>
                <span class="value">{{ customer.custAbbName || '-' }}</span>
              </div> -->
              <div class="item" style="width: 50%;">
                <span class="key">客户ID：</span>
                <span class="value">{{ customer.custCode }}</span>
              </div>
              <!-- <div class="item" style="width: 50%;">
                <span class="key">合作产品：</span>
                <span class="value">{{ customer.mainProducts  || '-' }}</span>
              </div> -->
              <!-- <div class="item">
                <span class="key">客户来源：</span>
                <span class="value">{{formatHandel('custSource',customer.custSource)}}</span>
              </div>
              <div class="item" style="width:100%">
                <span class="key">所属行业：</span>
                <span class="value">{{customer.industryName || '-' }}</span>
              </div>
              <div class="item" style="width:100%;">
                <span class="key">客户等级：</span>
                <span class="value">{{ formatHandel('custLevel',customer.custLevel) }}</span>
              </div>
              <div class="item">
                <span class="key">单位性质：</span>
                <span class="value">{{formatHandel('unitNature',customer.unitNature) || '-' }}</span>
              </div> -->
              <div class="item">
                <span class="key">地址：</span>
                <span class="value">{{customer.custAddress || '-'}}</span>
              </div>
              <div class="item">
                <span class="key">跟进：</span>
                <span class="value">{{customer.deptName}}    {{customer.userName}}</span>
              </div>
            </div>
              <!-- <div class="item">
                <span class="key">企业邮箱：</span>
                <span class="value">{{customer.enterpriseMailbox || '-' }}</span>
              </div>
              <div class="item" style="width:100%;">
                <span class="key">企业网站：</span>
                <span class="value">{{customer.website || '-' }}</span>
              </div> -->
              <!-- <div class="item" v-if="customer.custLogo">
                <span class="key">企业形象图片：</span>
                <img class="logo_img" :src="customer.custLogo" alt="">
              </div>
              <div class="item" v-if="customer.businessLicenseImg">
                <span class="key">营业执照：</span>
                <img class="logo_img" :src="customer.businessLicenseImg" alt="">
              </div>
            </div>
          </van-tab>
          <van-tab title="客户标签">
            <div class="list-wrap van-hairline--top">
              <div class="item">
                <span class="key">客户标签:</span>
                <span class="value" v-for="(item, index) in customer.custTagsList" :key="index"><van-tag size="large" style="margin: 5px;" plain type="primary">{{ item }}</van-tag></span>
                <empty v-if="customer.custTagsList" />
              </div>
            </div>
          </van-tab> -->
          <!--  <van-tab title="分类信息">
            <div class="list-wrap van-hairline--top">
              <div class="item">
                <span class="key">客户类型：</span>
                <span class="value">{{formatHandel('custType',customer.custType)}}</span>
              </div>
              <div class="item">
                <span class="key">客户状态：</span>
                <span class="value">{{formatHandel('custStatus',customer.custStatus)}}</span>
              </div>
             <div class="item">
                <span class="key">客户来源：</span>
                <span class="value">{{formatHandel('custSource',customer.custSource)}}</span>
              </div> -->
              <!-- <div class="item">
                <span class="key">单位性质：</span>
                <span class="value">{{formatHandel('unitNature',customer.unitNature) || '-' }}</span>
              </div>
              <div class="item" style="width:100%">
                <span class="key">企业规模：</span>
                <span class="value">{{formatHandel('scale',customer.scale) || '-' }}</span>
              </div>
             <div class="item" style="width:100%">
                <span class="key">行业名称：</span>
                <span class="value">{{customer.industryName || '-' }}</span>
              </div> -->
              <!-- <div class="item">
                <span class="key">行业级别：</span>
                <span class="value">{{formatHandel('custLevel',customer.custLevel) || '-' }}级</span>
              </div>
            </div>
          </van-tab> -->
          <!-- <van-tab title="账务">
            <div class="list-wrap van-hairline--top">
              <div class="item" style="width:100%">
                <span class="key">信用额度：</span>
                <span class="value">{{ customer.creditLimit || '-' }}</span>
              </div>
              <div class="item" style="width:100%">
                <span class="key">信用期间：</span>
                <span class="value">{{customer.creditPeriod || '-' }}</span>
              </div>
              <div class="item" style="width:100%">
                <span class="key">银行账号：</span>
                <span class="value">{{ customer.bankAccount || '-' }}</span>
              </div>
              <div class="item" style="width:100%">
                <span class="key">开户银行：</span>
                <span class="value">{{customer.bankDeposit || '-' }}</span>
              </div>
              <div class="item" style="width:100%">
                <span class="key">账户：</span>
                <span class="value">{{ customer.account || '-' }}</span>
              </div>
              <div class="item" style="width:100%">
                <span class="key">纳税识别号：</span>
                <span class="value">{{customer.custTaxNum || '-' }}</span>
              </div>
            </div>
          </van-tab>
          <van-tab title="操作日志">
            <div class="item">
              <van-steps direction="vertical" :active="100">
                <van-step v-for="(item,index) in operationLog" :key="index">
                  <span>{{item.content}}</span>
                  <div style="margin-top: 5px">{{item.createTime}}</div>
                </van-step>
              </van-steps>
            </div>
          </van-tab>
        </van-tabs> -->
        <!-- </div> -->
      </div>
        <!-- <span style="font-size: 20px;color: #2196f3;"  @click="edit"><van-icon name="edit" /></span> -->
      <div class="tab_box">
        <div class="tab_div" @click="toBoList"><img src="../../../assets/images/desktop/khsj.png" >商机<span>({{customer.map.boSum}})</span></div>
        <div class="tab_div" @click="toContractList"><img src="../../../assets/images/desktop/khht.png" >合同<span>({{customer.map.contSum}})</span></div>
        <div class="tab_div" @click="toPaymentList"><img src="../../../assets/images/desktop/khsk.png" >收款<span>({{customer.map.incomeSum}})</span></div>
      </div>
      <!-- 操作按钮区 -->
      <van-grid class="grid-wrap" :column-num="3">
        <van-grid-item>
          <div class="flex-center" v-hasPermi="['scrm:customer:edit']" @click="edit">
            <van-icon name="edit" size="22" color="#07c160" />
            <span>详情</span>
          </div>
        </van-grid-item>
        <van-grid-item>
          <div class="flex-center" v-hasPermi="['scrm:bo:add']" @click="handleAddBo">
            <van-icon name="add-o" size="22" color="#07c160" />
            <span>添加商机</span>
          </div>
        </van-grid-item>
        <van-grid-item>
          <div class="flex-center" v-hasPermi="['cont:newContract:add']" v-if="customer.custStatus != '1'" @click="addContract">
            <van-icon :name="require('../../../assets/images/desktop/khxzht.png')" size="22" color="#2EFE2E" />
            <span>添加合同</span>
          </div>
        </van-grid-item>
      </van-grid>
      <!-- 跟进 联系人-->
      <cont-tab class="cont-tab" :listVisitData="customer.visitList" :id="customer.custId" :custContactOptionsData="customer.contactList" :custObj="customer"
        :custStatusData="customer.custStatus" @handleaddvisit="addVisit" @handleAddBo="handleAddBo" @handleAddContacts="addContacts" :bolist="customer.boList" :operationLog = operationLog :name="customer.custName" />
    </div>
      <!-- 添加跟进记录 -->
    <van-dialog v-model="visitShow" title="添加跟进记录" class="editVisit"  :beforeClose="visitBeforeClose" close-on-click-overlay>
      <van-form ref="addVisitForm" validate-trigger="onSubmit" class="formSty">
        <van-cell-group>
          <van-field readonly clickable v-model="visitForm.boIdName" @click="showPicker('boId')" label="商机" placeholder="请选择商机" />
          <van-field readonly clickable v-model="visitForm.visitTypeName" @click="showPicker('visitType')" label="回访类型" placeholder="请选择回访类型" required />
          <van-field readonly clickable v-model="visitForm.contactIdName" label="联系人" @click="showPicker('contactId')" :rules="[{ required: true }]" placeholder="请选择联系人" required />
          <van-field v-model="visitForm.content" label="回访内容" type="textarea" :rules="[{ required: true }]" placeholder="请填写回访类容" required />
        </van-cell-group>
      </van-form>
    </van-dialog>

    <!-- 添加联系人 -->
      <van-dialog v-model="contactsShow" title="添加联系人" class="editVisit" :beforeClose="contactsBeforeClose" close-on-click-overlay>
        <van-form ref="addContactsForm" validate-trigger="onSubmit" class="formSty">
            <van-cell-group>
              <van-field v-model="contactsForm.contactName" label="联系人姓名" placeholder="请输入联系人姓名" :rules="[{ required: true }]" required />
              <van-field v-model="contactsForm.sexName" label="联系人性别" placeholder="请选择联系人性别" readonly
                @click="showPicker('sex')" :rules="[{ required: true }]" required />
              <van-field v-model="contactsForm.mobile" label="联系人手机" placeholder="请输入联系人手机" type="tel" maxLength="11"
                :rules="[
                  { required: true, message: '请填写您的手机号码！' },
                  { pattern: /^1[3456789]\d{9}$/, message: '手机号码格式错误！'}
                ]" required />
                <van-field v-model="contactsForm.jobs" label="联系人职务" placeholder="请输入联系人职务" :rules="[{ required: true }]" required />
            </van-cell-group>
        </van-form>
      </van-dialog>

    <van-popup v-model="picker.visible" position="bottom">
      <van-picker :title="picker.title" show-toolbar :columns="picker.columns" @confirm="pickerConfirm" @cancel="pickerCancel" @change="pickerChange" />
    </van-popup>
    <dialog-add :modifyObj="customer" :show='add_show' :isAdd='true' @handleAddBoCancel='handleAddBoCancel' @beforeClose='addBoBeforeClose' ></dialog-add>
  </div>
</template>

<script>
// import moment from 'moment'
import { getCust, addVisit, updateCust, getCustomerLogList, getSourceTree } from '@/api/scrm/mycust'
import { addContact } from '@/api/scrm/custcontact'
import ContTab from '../component/ContTab.vue'
// import Empty from '@/components/common/Empty'
import DialogAdd from '../component/DialogAddBo.vue'
// import { getDicts } from '@/api/system/dict/data'
import { Toast, Dialog } from 'vant'

export default {
  components: {
    ContTab,
    // Empty,
    DialogAdd,
    [Toast.name]: Toast,
    [Dialog.Component.name]: Dialog.Component
  },
  filters: {
    // timeFormat(val) {
    //   return moment(val).format('YYYY-MM-DD')
    // }
  },
  data() {
    return {
      contactsShow: false,
      add_show: false,
      contactsForm: {},
      visitShow: false,
      picker: {
        visible: false,
        title: '',
        columns: [],
        formKey: ''
      },
      visitForm: {},
      minDate: new Date(2010, 0, 1),
      minDateStart: new Date(2010, 0, 1),
      pattern: '/^(0|86|17951)?(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57])[0-9]{8}$/',
      customer: { map: {} },
      // 修改客户
      editCustShow: false,
      // 是否显示弹框
      show: false,
      // 生日
      showBirthdayCalendar: false,
      // 证件类型
      showPopupPicker: false,
      active: 0,
      form: {
        custId: null,
        custName: this.$route.query.custName,
        custType: this.$route.query.custType,
        custTypeName: this.$route.query.custTypeName,
        province: '',
        city: '',
        area: '',
        lng: '',
        lat: '',
        latLong: '',
        custAddress: '',
        contactList: [{
          contactName: '',
          callName: '',
          jobs: '',
          mobile: ''
        }]
      },
      // 客户操作日志
      operationLog: [],
      options: {
        // 客户类型字典
        custTypeOptions: this.$store.state.dictOptions.crmCustType || [],
        // 业务类型树选项
        businessTypeOptions: this.$store.state.dictOptions.businessTypeTree || [],
        // 客户来源字典
        custSourceOptions: this.$store.state.dictOptions.custSource || [],
        // 客户状态
        custStatusOptions: this.$store.state.dictOptions.custStatus || [],
        // 性别状态字典
        sexOptions: this.$store.state.dictOptions.sex || []
      }
    }
  },
  created() {
    this.getOptions()
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      document.title = 'SCRM-客户详情'
      this.getCustomer()
      this.getCustomerLogList()
    },
    async getCustomer() {
      const res = await getCust(this.$route.params.id)
      if (res.code === 200) {
        this.customer = res.data

        this.options.contactIdOptions = []
        const uLis = this.customer.contactList || []
        for (let i = 0; i < uLis.length; i++) {
          const element = uLis[i]
          const item = {
            dictValue: element.contactId,
            dictLabel: element.contactName
          }
          this.options.contactIdOptions.push(item)
        }
        this.options.boIdOptions = []
        const boLis = this.customer.boList || []
        for (let i = 0; i < boLis.length; i++) {
          const element = boLis[i]
          const item = {
            dictValue: element.boId,
            dictLabel: element.boName
          }
          this.options.boIdOptions.push(item)
        }
      }
      console.log(this.customer)
    },
    // 获取客户操作日志
    async getCustomerLogList() {
      const res = await getCustomerLogList({ custId: this.$route.params.id })
      if (res.code === 200) {
        this.operationLog = res.rows
      }
    },
    // 添加回访记录
    addVisit() {
      this.visitShow = true
    },
    // 添加联系人
    addContacts() {
      this.contactsShow = true
    },
    formatHandel(type, value) {
      const options = type + 'Options'
      if (value || value == 0) {
        return this.selectDictLabel(this.options[options], value)
      } else {
        return ''
      }
    },
    // 修改客户
    handleUpdate(custId) {
    },
    showPicker(type) {
      this.picker.formKey = type
      const optionItem = type + 'Options'
      this.picker.columns = this.options[optionItem].map((ele) => ele.dictLabel)
      this.picker.visible = true
    },
    pickerConfirm(value, key) {
      const optionItem = this.picker.formKey + 'Options'
      const name = this.picker.formKey + 'Name'
      if (this.picker.formKey == 'sex') {
        this.contactsForm[this.picker.formKey] = this.options[optionItem][key].dictValue
        this.contactsForm[name] = this.options[optionItem][key].dictLabel
      } else {
        this.visitForm[this.picker.formKey] = this.options[optionItem][key].dictValue
        this.visitForm[name] = this.options[optionItem][key].dictLabel
      }
      this.picker.visible = false
    },
    pickerCancel() {
      this.picker.visible = false
    },
    pickerChange() {

    },
    // 修改客户
    async editCustBeforeClose(type, done) {
      if (type === 'confirm') {
        try {
          await this.$refs.editForm.validate()
          updateCust(this.form).then(response => {
            this.getCustomer()
            Toast.success('修改成功!')
            this.editCustShow = false
          })
          done()
        } catch (err) {
          return done(false)
        }
        return done(false)
      } else {
        return done()
      }
    },
    edit() {
      this.$router.push('/scrm/myCust/modifyInfos?custId=' + this.customer.custId)
    },
    toBoList() {
      this.$router.push('/scrm/businessOpportunity/index?custId=' + this.customer.custId)
    },
    toContractList() {
      this.$router.push('/cont/approve/list?custId=' + this.customer.custId)
    },
    toPaymentList() {
      this.$router.push('/cont/payment/confirmList?custId=' + this.customer.custId)
    },
    remove() {

    },
    // 添加回访记录
    async visitBeforeClose(type, done) {
      if (type === 'confirm') {
        try {
          await this.$refs.addVisitForm.validate()

          this.visitForm.custId = this.customer.custId
          this.visitForm.custName = this.customer.custName
          this.visitForm.contactName = this.visitForm.contactIdName
          addVisit(this.visitForm).then(response => {
            // 选择商机时获取该商机的回访记录
            this.visitShow = false
            this.visitForm.content = null
            // this.visitForm.visitType = null
            // this.visitForm.contactId = null
            this.getCustomer()
            Toast.success('回访记录添加成功!')
          })
          done()
        } catch (err) {
          return done(false)
        }
        return done(false)
      } else {
        return done()
      }
    },
    // 添加联系人
    async contactsBeforeClose(type, done) {
      if (type === 'confirm') {
        try {
          await this.$refs.addContactsForm.validate()
          this.contactsForm.custId = this.customer.custId
          addContact(this.contactsForm).then(response => {
            // this.contactsShow = false
            // this.contactsForm.contactName = null
            // this.contactsForm.contactPhone = null
            // this.contactsForm.contactEmail = null
            // this.contactsForm.contactQq = null
            // this.contactsForm.contactWechat = null
            // this.contactsForm.contactRemark = null
            Toast.success('联系人添加成功!')
            this.getCustomer()
          })
          done()
        } catch (err) {
          return done(false)
        }
        return done(false)
      } else {
        return done()
      }
    },
    handleAddBo() {
      if (!this.customer.unitNature || !this.customer.custLevel || !this.customer.industryCode) {
        Toast.fail('请先完善客户信息')
        setTimeout(() => {
          this.$router.push('/scrm/myCust/modifyInfos?custId=' + this.customer.custId)
        }, 500)
        return
      }
      this.add_show = true
    },
    addContract() {
      this.$router.push('/cont/contract/add?customer=' + JSON.stringify(this.customer))
    },
    handleAddBoCancel() {
      this.add_show = false
    },
    // 添加合同
    async addBoBeforeClose(val) {
      this.add_show = false
      await this.getCustomer()
    },
    getOptions() {
      this.getDicts('crm_mycust_type').then(res => {
        this.options.custTypeOptions = res.data
      })
      this.getDicts('crm_scale').then(res => {
        this.options.scaleOptions = res.data
      })
      this.getDicts('crm_cust_status').then(res => {
        this.options.custStatusOptions = res.data
      })
      this.getDicts('crm_acquire_way').then(res => {
        this.options.acquireWayOptions = res.data
      })
      this.getDicts('crm_unit_nature').then(res => {
        this.options.unitNatureOptions = res.data || []
      })
      this.getDicts('crm_cust_level').then(res => {
        this.options.custLevelOptions = res.data
      })
      this.getDicts('crm_call_name').then(res => {
        this.options.callNameOptions = res.data
      })
      // this.getDicts('crm_cust_source').then(res => {
      //   this.options.custSourceOptions = res.data
      // })
      getSourceTree().then(res => {
        this.options.custSourceOptions = res.rows.map(item => { return { dictLabel: item.custSourceName, dictValue: item.custSourceId } })
      })
      // 证件类型
      this.getDicts('crm_ide_type').then(res => {
        this.options.ideTypeOptions = res.data
      })
      // 亲密度
      this.getDicts('crm_intimacy').then(res => {
        this.options.intimacyOptions = res.data
      })
      // 性别
      this.getDicts('sys_user_sex').then(res => {
        this.options.sexOptions = res.data
      })
      this.getDicts('crm_visit_type').then(res => {
        this.options.visitTypeOptions = res.data
      })
      // 性别
      this.getDicts('sys_user_sex').then(res => {
        this.options.sexOptions = res.data
      })
    },
    formatDate(date) { // 时间格式化 2019-09-08
      const year = date.getFullYear()
      const month = date.getMonth() + 1
      const day = date.getDate()
      return year + '-' + month + '-' + day
    }
  }
}
</script>
<style lang="less" scoped>
@import url("@/style/index.less");
/* 跟进记录 */
/deep/.van-tabs__line {
  position: absolute;
  bottom: 0.4rem;
  left: 0;
  z-index: 1;
  width: 1rem;
  height: 0.08rem;
  background-color: #bbb;
  border-radius: 0.08rem;
  top:1rem;
}
/deep/.van-tab__text{
  font-weight: bold;
}
.cont-tab{
  overflow-y: hidden;
  // .pb(120);
}
// .concat-list{
//     // height: auto;
//     overflow: scroll;
// }

.editVisit{
    min-height: 9rem;
    height: 50%;
    top: 46%;
    .formSty{
      height: 100%; overflow: scroll; margin: 10px 5px;
    }
}
.editVisit /deep/.van-dialog__content {
  height: 83%;
  .van-field--error .van-field__control{
    font-size: 0.38rem;
  }
  .van-field__control{font-size: 0.38rem;}
}
.editVisit /deep/.van-dialog__content {
  height: 70%;
}
.container{
  .card{
    min-height: 200px;
    .tag_box{
      .van-tag{
        margin-left: 12px;
      }
    }
  }
  .tab_box{
    background-color: #fff;
    margin: 20px 0;
    padding: 40px;
    border-radius: 10px;
    display: flex;
    justify-content: space-between;
    .tab_div{
      display: flex;
      align-items: center;
      color: #333;
      font-size: 30px;
      img{
        width: 50px;
        height: 50px;
        margin-right: 5px;
      }
      span{
        color: #1989fa;
      }
    }
  }
}
.modify_img{
  width: 66px;
  height: 66px;
  margin-left:auto;
}
</style>
